import { Docs } from "~/bff/types/Docs";
import { Nullable } from "~/types/general.types";
import { LoadingDirection } from "~/types/requestHandlers";

export const getNewItems = (
  shouldConcat: boolean,
  direction: LoadingDirection,
  loadedItems: Nullable<Nullable<Docs>[]>,
  items: Nullable<Nullable<Docs>[]>,
): Nullable<Nullable<Docs>[]> => {
  if (shouldConcat) {
    if (direction === "previous" && loadedItems) {
      return loadedItems.concat(items);
    } else if (direction === "next" && items) {
      return items.concat(loadedItems);
    } else {
      return loadedItems;
    }
  }
  return loadedItems;
};
